///<reference path="../require.d.ts"/>
import {parse} from "qs";

interface Location {
    id: string;
    key: string;
    value: string;
    name: string;
    kana: string;
    parent_name: string;
    parent_name_kana: string;
}

interface Escape {
    (input: string): string;
}

class CriteriaController {

    static $inject = ["$scope", "$element", "$http"];

    q: string;
    unit: string = '月';
    priceType: string = '30';
    priceFrom: number;
    priceTo: number;
    $select: JQuery;

    locations: Location[];

    constructor(
        private $scope: angular.IScope,
        private $element: angular.IAugmentedJQuery,
        private $http: angular.IHttpService
    ) {
        this.locations = [];
        this.initSelect();
        this.initCriteria();
    }

    initCriteria(): void {
        const qs = location.search;
        if (!qs || qs === '') return;
        const params = parse(qs.substr(1));
        this.restoreCriteria(params);
        this.loadCurrentLocations(params);
    }

    restoreCriteria(params: any): void {
        this.q = params.q
        this.priceType = params.price_type;
        const pf = Number(params.price_from);
        if (!isNaN(pf) && pf > 0) this.priceFrom = pf;
        const pt = Number(params.price_to);
        if (!isNaN(pt) && pt > 0) this.priceTo = pt;
    }

    loadCurrentLocations(params: any): void {
        if (params.hasOwnProperty('city_id') || params.hasOwnProperty('station_id')) {
            const c = {city_id: params.city_id, station_id: params.station_id};
            const qs = jQuery.param(c);
            this.$http.get<Location[]>(`${apiRoot}/locations?${qs}`).success((result) => {
                this.locations = result;
            });
        }
    }

    initSelect(): void {
        this.$select = this.$element.find(".select-location");
        if (this.$select.length === 0) return;
        this.$select.select2({
            id: (o: any) => o.id,
            multiple: false,
            closeOnSelect: true,
            ajax: {
                url: `${apiRoot}/locations`,
                dataType: 'json',
                delay: 100,
                processResults: (data: any) => {
                    return {results: data};
                },
            },
            language: 'ja',
            escapeMarkup: (markup: string) => markup,
            templateResult: this.formatResult,
            templateSelection: this.formatSelection,
            theme: 'bootstrap',
        });
        this.$select.on('select2:select', (e: any) => this.onSelect(e));
    }

    // TODO select2.d.ts が古い？ 実際に渡ってくるイベントオブジェクトと異なる。
    onSelect(e: any): any {
        const loc = e.params.data as Location;
        const found = this.locations.filter((c) => c.id === loc.id);
        if (found.length === 0) this.locations.push(loc);
        this.$select.val(null).trigger("change");
        this.$scope.$apply();
    }

    formatSelection(r: Select2SelectionObject & Location): any {
        return `${r.parent_name} ${r.name}`;
    }

    formatResult(r: Select2SelectionObject & Location): any {
        if (!r.name) {
            return '検索中...';
        }
        return `
            <div class="location-item">
                <div class="location-item__name">${r.parent_name} ${r.name}</div>
                <div class="location-item__kana">（${r.parent_name_kana} ${r.kana}）</div>
            </div>
        `;
    }

    remove(loc: Location): void {
        this.locations = this.locations.filter((l) => l !== loc);
    }

    updateUnit(): void {
        this.unit = this.selectUnit();
    }

    selectUnit(): string {
        const pt = Number(this.priceType);
        if (pt === 7) {
            return "週";
        } else {
            return "月";
        }
    }

}

angular.module('hp').controller('CriteriaController', CriteriaController);



// WEBPACK FOOTER //
// ./controllers/CriteriaController.ts